import React from "react";
import translate from "i18n/translate";
import { SrButton, SrDialog, Typography } from "../../../common";

const CancelCardDialog = ({ onSubmit, handleClose, loading }) => (
  <SrDialog
    handleClose={handleClose}
    heading={translate("srPagoCard.card.cancelTitle")}
    actions={
      <>
        <SrButton onClick={handleClose}>{translate("common.cancel")}</SrButton>
        <SrButton
          type="submit"
          variant="contained"
          color="primary"
          onClick={onSubmit}
          disabled={loading}
        >
          {translate("common.confirm")}
        </SrButton>
      </>
    }
  >
    <Typography>{translate("srPagoCard.card.cancelContent")}</Typography>
  </SrDialog>
);

export default CancelCardDialog;
